import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

const DeleteBoxPhoneModal = ({ isOpen, onConfirm, onCancel, title, body }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <div>{body}</div>
        <div style={{ color: '#3b5aa9' }}>{/* Warning: This function cannot be undone! */}</div>
      </ModalBody>
      <ModalFooter className="modalFooterEpiDelete">
        <Button outline color="secondary" onClick={onCancel}>
          No
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteBoxPhoneModal;
